
import { Component, Mixins } from "vue-property-decorator";
import { NumberRangeAlertBehavior } from "../../../../../../documaker/domain/format/objects";
import { INumberRangeAlertBehaviorPropertyEditable, instanceOfINumberRangeAlertBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class NumberRangeAlertBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INumberRangeAlertBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INumberRangeAlertBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isNumberRangeAlertBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfINumberRangeAlertBehaviorPropertyEditable(s) && s.numberRangeAlertBehavior().isEditable(), false);
  }

  get numberRangeAlertBehavior(): NumberRangeAlertBehavior {
    return this.readPropertyOrDefault(s => NumberRangeAlertBehavior.from(s.numberRangeAlertBehavior().getValue()), new NumberRangeAlertBehavior(null, null));
  }

  set numberRangeAlertBehavior(value: NumberRangeAlertBehavior) {
    this.writePropertyWhenValid(s => s.numberRangeAlertBehavior().setValue(NumberRangeAlertBehavior.to(value)));
  }
}
